import React from 'react';
import MaterialIcon from '../icon/Icon.material';
import { GLOBAL_ICONS } from '../../util/vars';

interface Props {
  title: string;
  badge?: string;
  open: boolean;
  onToggle: () => void;
  // Keep the body rendered (just hidden) while closed, so stateful content such as an in-progress draft survives.
  keepMounted?: boolean;
  dataCy?: string;
  children: React.ReactNode;
}

const CollapsibleCard = ({ title, badge, open, onToggle, keepMounted = false, dataCy, children }: Props): JSX.Element => (
  <article data-cy={dataCy} className={'border border-gray-200 rounded-default'}>
    <button type={'button'} className={'w-full flex items-center justify-between gap-3 px-4 py-3 text-left'} aria-expanded={open} onClick={onToggle}>
      <span className={'flex flex-wrap items-center gap-2'}>
        <h4 className={'text-sm font-semibold'}>{title}</h4>
        {badge && <span className={'text-xs bg-gray-100 rounded px-2 py-0.5'}>{badge}</span>}
      </span>
      <MaterialIcon icon={GLOBAL_ICONS[open ? 'toggle_on' : 'toggle_off']} />
    </button>
    {keepMounted ? <div hidden={!open}>{children}</div> : open && children}
  </article>
);

export { CollapsibleCard };
